// extracted by mini-css-extract-plugin
export default {"alignRight":"Pagination_alignRight__32nZC"};